import { RoutePath } from '../pages';
import { useAccount } from './useAccount';
import { useRouter } from './useRouter';

export type UseModalProps = {
  onConnect?: ({ address, connectorId }: { address?: string; connectorId?: string }) => void;
  onDisconnect?: () => void;
};

// TODO: callback
export const useModal = ({ onConnect, onDisconnect }: UseModalProps = {}) => {
  const { navigate, close, isOpen } = useRouter();
  const { isConnected } = useAccount();

  return {
    isOpen,
    setOpen: (open: boolean) => {
      if (open) {
        navigate(isConnected ? RoutePath.WalletInfo : RoutePath.Signup);
      } else {
        close();
      }
    },
  };
};
